import { DailyPlanScreen, DailyReportsScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeDailySource } from '../daily-source.js';

/** Operations ▸ Daily Works Plan (ADR 0051): ofiste salt okunur, gemi seçicili. */
export function DailyPlanPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.operationsDailyPlan')}>
      <DailyPlanScreen source={officeDailySource} />
    </Shell>
  );
}

/** Operations ▸ Daily Reports (ADR 0051): ofiste gönderilmiş raporlar, salt okunur. */
export function DailyReportsPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.operationsDailyReports')}>
      <DailyReportsScreen source={officeDailySource} />
    </Shell>
  );
}
